import styled from "@emotion/styled";
import {PrimaryButton} from "components/Common";
import {breakpoints} from "assets/theme";

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	border-radius: 4px;
	background: ${({theme}) => theme.colorPalette.secondary};
`;

export const Item = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex: 1;
	padding: 8px 12px;
	border-right: 1px solid #545456;
	border-left: 1px solid #545456;

	&:first-child {
		border-left: none;
	}
	&:last-child {
		border-right: none;
	}

	@media (min-width: ${breakpoints.medium}) {
		padding: 20px;
	}
`;

export const Value = styled.div`
	font-size: 20px;
	font-weight: 700;
	line-height: 120%;
	letter-spacing: 0.2px;
`;

export const Button = styled(PrimaryButton)`
	width: 100%;
`;
